// PageMenu — the "···" sheet every list page and every row action menu opens
// at ≤880px (mobile overhaul Phase 0 §0.5.2; mockup §3.1 C). A half sheet of
// SheetRows with no header when no title is given: the rows start straight
// under the grab handle. Row menus ("···" on a task) use the same component —
// see the RowMenu alias below.

import type { ReactNode } from 'react';
import { Sheet, SheetRow } from './Sheet';

export interface PageMenuItem {
  key: string;
  className?: string;
  icon?: ReactNode;
  label: string;
  /** Small mono line under the label — "Due date · soonest first". */
  sublabel?: string;
  tone?: 'danger';
  disabled?: boolean;
  /** Keep download progress visible in the menu. */
  keepOpen?: boolean;
  onSelect: () => void;
}

export function PageMenu({
  open,
  onClose,
  items,
  title,
}: {
  open: boolean;
  onClose: () => void;
  items: PageMenuItem[];
  /** Omit for the mockup's headerless menu; set it for a named sub-sheet. */
  title?: string;
}) {
  return (
    <Sheet
      open={open}
      onClose={onClose}
      variant="half"
      title={title}
      ariaLabel={title ?? 'Actions'}
      className="pmenu"
    >
      {items.map((item) => (
        <SheetRow
          key={item.key}
          className={item.className}
          icon={item.icon}
          label={item.label}
          sub={item.sublabel}
          tone={item.tone}
          disabled={item.disabled}
          role="menuitem"
          onSelect={() => {
            if (!item.keepOpen) onClose();
            item.onSelect();
          }}
        />
      ))}
    </Sheet>
  );
}

/** A row's "···" sheet is a PageMenu — same rows, same behaviour. Alias so
    call sites read the way the mockups label them. */
export const RowMenu = PageMenu;
